module.exports = __webpack_public_path__ + "img/logo.dfe85a04.svg";